import { DetailedOutletWithLoading } from '../comparison.state';
import { formatter } from '../utils';

import { AddOutlet } from './AddOutlet';
import { DummyTable } from './DummyTable';
import { TableCard } from './TableCard';

const HEADERS = [
  {
    title: 'Sales Summary',
    sub: ['Gross Sales', 'Net Sales', 'Gross Profit', 'Transaction', 'Average Sale per Transaction', 'Gross Margin'],
  },
  {
    title: 'Items',
    sub: [<div className="h-[60px]">Top 3 Items</div>],
  },
];

interface TableSummaryProps {
  readonly selectedOutletIds: readonly number[];
  readonly outlets: Map<number, DetailedOutletWithLoading>;
  readonly isFeatureAvailable: boolean;
  readonly canRemove: boolean;
  readonly canAddMore: boolean;
  readonly onRemove?: (...itemIds: number[]) => void;
}

function generateTableData(outlet?: DetailedOutletWithLoading) {
  const { name, grossSales, netSales, transaction, grossProfit, averageSalePerTransaction, grossMargin, topItems } = outlet || {};
  const topItemsHtml = (
    <ol className="h-[60px]">
      {topItems?.map((item, index) => (
        <li key={index} className="truncate">
          {index + 1}. {item}
        </li>
      ))}
    </ol>
  );

  return [
    {
      title: name,
      sub: [
        formatter('currency', grossSales),
        formatter('currency', netSales),
        formatter('currency', grossProfit),
        formatter('decimal', transaction),
        formatter('currency', averageSalePerTransaction),
        formatter('percent', grossMargin),
      ],
    },
    {
      title: '',
      sub: [topItemsHtml],
    },
  ];
}

function TableSummary({ selectedOutletIds, outlets, canRemove, canAddMore, isFeatureAvailable, onRemove }: TableSummaryProps) {
  return (
    <div className="mb-10">
      <div className="mb-2 border-b border-neutral-300 pb-1">
        <h2 className="text-lg text-neutral-700">TABLE SUMMARY</h2>
      </div>

      <div className="grid grid-cols-[238px_1fr]">
        <div className="pt-3">
          <TableCard variant="header" data={HEADERS} />
        </div>
        <div className="ml-3 flex gap-6 overflow-x-auto pb-4 pl-3 pt-3">
          {isFeatureAvailable ? (
            <>
              {selectedOutletIds.length > 1
                ? selectedOutletIds
                    .map((id) => outlets.get(id) as DetailedOutletWithLoading)
                    .map((data) => {
                      return (
                        <TableCard
                          key={data?.id}
                          id={data?.id}
                          variant="body"
                          data={generateTableData(data)}
                          isLoading={data?.isLoading}
                          removable={canRemove}
                          onClickRemove={onRemove}
                        />
                      );
                    })
                : null}
              {canAddMore ? <AddOutlet /> : null}
            </>
          ) : (
            <DummyTable />
          )}
        </div>
      </div>
    </div>
  );
}

export { TableSummary, generateTableData as _generateTableData };
